<span class="status-badge" [ngClass]="statusConfig.cssClass" [matTooltip]="statusConfig.tooltip">
    {{ statusConfig.label }}
</span>
